// extracted by mini-css-extract-plugin
export var quote = "ArticleQuote-module--quote--2DmAI";
export var verticalDash = "ArticleQuote-module--verticalDash--3fOeu";
export var quoteText = "ArticleQuote-module--quoteText--CdQYK";